import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Home.vue"),
    meta: {
      title: "首页",
      menuIndex: 0,
      isShow: true,
    },
  },
  {
    path: "/directoryList",
    name: "directoryList",
    component: () => import("@/views/directory-list.vue"),
    meta: {
      title: "名录列表",
    },
  },
  {
    path: "/service",
    name: "certificate-service",
    component: () => import("@/views/certificateService/certificateIndex.vue"),
    meta: {
      title: "认证服务",
      menuIndex: 1,
      isShow: true,
    },
    children: []
  },
  {
    path: "/service/certification",
    name: "certification",
    component: () => import("@/views/certificateService/certificationContent.vue"),
    meta: {
      title: "认证服务",
      menuIndex: 1,
      f: true,
    },
  },
  {
    path: "/service/books",
    name: "books",
    component: () => import("@/views/certificateService/booksContent.vue"),
    meta: {
      title: "认证服务-相关书籍",
      menuIndex: 1,
      f: true,
    },
  },
  {
    path: "/lab",
    name: "labDetail",
    component: () => import("@/views/labDetail.vue"),
    meta: {
      title: "实验室详情",
      menuIndex: 1,
      f: true,
    },
  },
  {
    path: "/expert",
    name: "expert-mange",
    component: () => import("@/views/expert-manage.vue"),
    meta: {
      title: "专家管理",
      isShow: false,
    },
  },
  {
    path: "/expert/expertDetail",
    name: "expertDetail",
    component: () => import("@/views/expertDetail.vue"),
    meta: {
      title: "专家详情",
      isShow: false,
    },
  },
  {
    path: "/article/articleDetail",
    name: "articleDetail",
    component: () => import("@/views/articleDetail.vue"),
    meta: {
      title: "案例详情",
      isShow: false,
    },
  },
 
  {
    path: "/service/articleList",
    name: "articleList",
    component: () => import("@/views/certificateService/articleList.vue"),
    meta: {
      title: "认证服务-列表",
      menuIndex: 1,
      f: true,
    },
  },
  {
    path: "/service/article-detail",
    name: "serviceArticleDetail",
    component: () => import("@/views/certificateService/articleDetail.vue"),
    meta: {
      title: "认证服务-文章详情",
      menuIndex: 1,
      f: true,
    },
  },
  // {
  //   path: '/certification',
  //   name: 'certification',
  //   component: () => import("@/views/Certification.vue"),
  //   meta:{
  //     title: '场地验收'
  //   }
  // },
  {
    path: "/news",
    name: "news",
    component: () => import("@/views/news/News.vue"),
    // redirect: '/news/announce',
    meta: {
      title: "新闻资讯",
      menuIndex: 2,
      isShow: true,
    },
    children:[
      {
        path: "announce",
        name: "announce",
        component: () => import("@/views/news/announce.vue"),
        meta: {
          menuIndex: 2,
          title: "新闻通告"
        },
      },
      {
        path: "athletics",
        name: "athletics",
        component: () => import("@/views/news/athletics.vue"),
        meta: {
          menuIndex: 2,
          title: "田径文化"
        },
      },
      {
        path: "directory",
        name: "newsdirectory",
        component: () => import("@/views/news/directory.vue"),
        meta: {
          menuIndex: 2,
          title: "名录公示"
        },
      }
    ]
  },
  {
    path: "/news/newsDetail",
    name: "newsDetail",
    component: () => import("@/views/news/news-detail.vue"),
    meta: {
      menuIndex: 2,
      title: "新闻详情",
      f: true,
    },
  },
  {
    path: "/news/certDetail",
    name: "certDetail",
    component: () => import("@/views/news/cert-detail.vue"),
    meta: {
      menuIndex: 2,
      title: "证书详情",
      f: true,
    },
  },
  {
    path: "/booksDetail",
    name: "booksDetail",
    component: () => import("@/views/news/books-detail.vue"),
    meta: {
      title: "书籍详情"
    },
  },
  {
    path: "/more",
    name: "more",
    component: () => import("@/views/news/more.vue"),
    meta: {
      title: "查看更多",
      menuIndex: 2,
    },
  },
  {
    path: "/directoryMore",
    name: "directoryMore",
    component: () => import("@/views/news/directoryMore.vue"),
    meta: {
      title: "名录列表"
    },
  },
  {
    path: "/footPath",
    name: "footPath",
    component: () => import("@/views/foot-path.vue"),
    meta: {
      title: "场地步道",
      menuIndex: 3,
      isShow: true,
    },
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/About.vue"),
    meta: {
      title: "关于我们",
      isShow: true,
      menuIndex: 4,
    },
  },
  {
    path: "/directory",
    name: "directory",
    component: () => import("@/views/directory.vue"),
    meta: {
      title: "名录",
    },
  },
  // 已做完
  // {
  //   path: '/register',
  //   name: 'register',
  //   component: () => import("@/views/register.vue"),
  //   meta:{
  //     title: '培训&注册'
  //   }
  // },
  // {
  //   path: '/book',
  //   name: 'book',
  //   component: () => import("@/views/books.vue"),
  //   meta:{
  //     title: '相关书籍'
  //   }
  // },
  // {
  //   path: '/rules',
  //   name: 'manageRules',
  //   component: () => import("@/views/management-rules.vue"),
  //   meta:{
  //     title: '审定验收'
  //   }
  // },

  {
    path: '/search',
    name: 'search-mange',
    component: () => import("@/views/search-manage.vue"),
    meta:{
      title: '搜索',
      menuIndex: 0,
    }
  },
];

const router = new VueRouter({
  routes,
});

router.scrollBehavior = () => {
  return {
    x: 0,
    y: 0
  }
};

router.beforeEach((to, from, next) => {
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next()
})


router.afterEach((t, f) => {
  // if(!(['/news/announce', '/news/athletics', '/news/directory'].includes(f.path) && ['/news/announce', '/news/athletics', '/news/directory'].includes(t.path))){
    document.documentElement.scrollTop = document.body.scrollTop = 0;
    scrollTo({ top: 0 });
  // }
})
export default router;
